import { render, staticRenderFns } from "./sider.vue?vue&type=template&id=78749caf"
import script from "./sider.vue?vue&type=script&lang=js"
export * from "./sider.vue?vue&type=script&lang=js"
import style0 from "./sider.vue?vue&type=style&index=0&id=78749caf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports